/* eslint-disable no-unused-vars */
import { Button, Input, InputNumber, Modal, Select, Spin, message } from 'antd'
import { wind2PerformanceUpdate } from 'api/pgads'
import { ErrorContext, JcTmpErrorContext, SpinContext } from 'context'
import { monthsMap } from 'core'
import JcTmpErrorDialog, {
  isErrorContains,
} from 'core/component/JcTmpErrorDialog'
import { Label } from 'core/screen-util'
import React, { useContext, useMemo, useState } from 'react'
import { windStoragePerformanceSave } from './wind2api'
import { connect } from 'react-redux'
import { getPermitActions } from '../core/selectors'
import { WIND_ADMIN_POWER_DATA_20 } from '../core/EventActions'
import { hasAccesPermits } from 'core/utils'

const Wind2StoragePerformanceDialog = ({
  data,
  targetInfo,
  visible,
  onHide = _ => _,
  onRetrieve,
  isNew = false,
  avalibilityStatusIdMap,
  avaliablitilityStatusList,
  actionPermits,
}) => {
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [insertData, setInsertData] = useState(data)
  const { setTmpError } = useContext(JcTmpErrorContext)

  const hasWindPowerDataWritePermission = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [WIND_ADMIN_POWER_DATA_20],
        matchAny: true,
      }),
    [actionPermits]
  )

  const onSave = _ => {
    setSpinning(true)
    windStoragePerformanceSave(targetInfo)([
      { ...insertData, action: isNew ? 'A' : 'U' },
    ]).fork(setError, errorList => {
      setSpinning(false)
      setTmpError(errorList)
      if (!isErrorContains(errorList)) {
        message.info('Data saved.')
        onHide()
        onRetrieve()
      }
    })
  }

  return (
    <Modal
      onCancel={onHide}
      visible={visible}
      footer={
        <div>
          <div>
            {hasWindPowerDataWritePermission && (
              <Button type="primary" onClick={onSave}>
                Save{' '}
              </Button>
            )}
            <Button onClick={onHide}>Cancel</Button>
          </div>
        </div>
      }
      centered
      height={400}
      width={1200}
      title={<div>Storage Performance Data : {insertData.subgroupName}</div>}
    >
      <Spin spinning={spinning}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '230px  150px 120px 100px 100px 100px',
            gap: 5,
            width: 1000,
          }}
        >
          <Label>Availability Status :</Label>
          <Select
            style={{ gridColumnEnd: 'span 3' }}
            value={insertData.storageGroupAvailability}
            onChange={storageGroupAvailability =>
              setInsertData({ ...insertData, storageGroupAvailability })
            }
          >
            {avaliablitilityStatusList.map(
              ({ avaliabilityStatusCode, avaliabilityStatusName }) => (
                <Select.Option
                  value={avaliabilityStatusCode}
                  key={avaliabilityStatusCode}
                >
                  {avaliabilityStatusName}
                </Select.Option>
              )
            )}
          </Select>
          <div style={{ gridColumnEnd: 'span 2' }} />

          <Label>Charge MWh :</Label>
          <InputNumber
            value={insertData.chargeMwh}
            onChange={chargeMwh => setInsertData({ ...insertData, chargeMwh })}
          />

          <Label>Discharge MWh :</Label>
          <InputNumber
            value={insertData.dischargeMwh}
            onChange={dischargeMwh =>
              setInsertData({ ...insertData, dischargeMwh })
            }
          />

          <Label>FO Hrs :</Label>
          <InputNumber
            value={insertData.foHrs}
            onChange={foHrs => setInsertData({ ...insertData, foHrs })}
          />

          <Label>Charge Hrs :</Label>
          <InputNumber
            value={insertData.chargeHrs}
            onChange={chargeHrs => setInsertData({ ...insertData, chargeHrs })}
          />

          <Label>Discharge Hrs :</Label>
          <InputNumber
            value={insertData.dischargeHrs}
            onChange={dischargeHrs =>
              setInsertData({ ...insertData, dischargeHrs })
            }
          />

          <Label>MO Hrs :</Label>
          <InputNumber
            value={insertData.moHrs}
            onChange={moHrs => setInsertData({ ...insertData, moHrs })}
          />

          <div style={{ gridColumnEnd: 'span 4' }} />
          <Label>PO Hrs :</Label>
          <InputNumber
            value={insertData.poHrs}
            onChange={poHrs => setInsertData({ ...insertData, poHrs })}
          />
        </div>
      </Spin>
    </Modal>
  )
}

const mapStateToProps = state => ({
  // eventTypes: getEventTypes(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(Wind2StoragePerformanceDialog)
